import { Archive, CheckCircle, Clock, Send, XCircle } from 'lucide-react'

const STATUS_CONFIG = {
  SENT: { label: 'Envoyée', icon: Send, className: 'text-slate-500 bg-slate-100' },
  IN_DISCUSSION: { label: 'En discussion', icon: Clock, className: 'text-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.08)]' },
  ACCEPTED: { label: 'Acceptée', icon: CheckCircle, className: 'text-green-700 bg-green-50' },
  REJECTED: { label: 'Refusée', icon: XCircle, className: 'text-red-700 bg-red-50' },
  CLOSED: { label: 'Clôturée', icon: Archive, className: 'text-slate-500 bg-slate-100' },
}

export default function ApplicationStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.SENT
  const Icon = config.icon

  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${config.className}`}>
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  )
}
